/* eslint-disable */
export default {
  createCallLog: 'Créer journal',
  viewInSalesforce: 'Afficher dans Salesforce',
  createLog: 'Créer un journal',
} as const;

// @key: @#@"createCallLog"@#@ @source: @#@"Create call log"@#@
// @key: @#@"viewInSalesforce"@#@ @source: @#@"View in Salesforce"@#@
// @key: @#@"createLog"@#@ @source: @#@"Create log"@#@
